import { render, staticRenderFns } from "./contract-view-dialog.vue?vue&type=template&id=082d7536&scoped=true"
import script from "./contract-view-dialog.vue?vue&type=script&lang=js"
export * from "./contract-view-dialog.vue?vue&type=script&lang=js"
import style0 from "./contract-view-dialog.vue?vue&type=style&index=0&id=082d7536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082d7536",
  null
  
)

export default component.exports